/**
 * A extensão instalada tem o gateway do WhatsApp (capacidade `whatsapp-gateway-v1`)? Enquanto a
 * extensão com o gateway não sai na loja, o item Grupos do WhatsApp do menu Ferramentas só aparece
 * para quem tem essa extensão: sem ela, a página só pediria para atualizar.
 */
import { useEffect, useState } from 'react';
import { getExtensionCapabilities } from '../../lib/extensionBridge';
import { WHATSAPP_GATEWAY_CAPABILITY } from '../../lib/whatsappGateway';

let known = false;
let inFlight: Promise<boolean> | null = null;

export function whatsappGatewayAvailable(): Promise<boolean> {
  if (known) return Promise.resolve(true);
  if (!inFlight) {
    inFlight = getExtensionCapabilities()
      .then((response) => {
        const list = response?.capabilities;
        known = Array.isArray(list) && list.includes(WHATSAPP_GATEWAY_CAPABILITY);
        return known;
      })
      .catch(() => false)
      // A resposta negativa não fica guardada: a extensão pode ser atualizada com o painel aberto.
      .finally(() => {
        inFlight = null;
      });
  }
  return inFlight;
}

export function useWhatsappGatewayAvailable(enabled: boolean): boolean {
  const [available, setAvailable] = useState(known);

  useEffect(() => {
    if (!enabled || available) return undefined;
    let alive = true;
    const check = (): void => {
      void whatsappGatewayAvailable().then((ok) => {
        if (alive && ok) setAvailable(true);
      });
    };
    check();
    window.addEventListener('focus', check);
    return () => {
      alive = false;
      window.removeEventListener('focus', check);
    };
  }, [available, enabled]);

  return available;
}
